import { useProductBrowser } from '~/techstyle-shared/react-components';

export default function useStyleGuideFilterData(tagListInput) {
  const { filterSettings } = useProductBrowser();
  const styleGuideFilterObj = filterSettings?.find(
    ({ field }) => field === tagListInput
  );
  const filterOptions = styleGuideFilterObj?.items;
  const tagList = styleGuideFilterObj?.field;
  const filterValues = filterOptions?.map((filter) => filter.value);
  return { tagList, filterValues };
}
